import { useRouteError } from 'react-router-dom';
import { IconAlertTriangle } from '@tabler/icons-react';
import { TwContainer } from '@/lib/components/TwContainer';

const NotFound = () => {
	const error = useRouteError() as Error;
	return (
		<TwContainer className={'py-96  mx-auto text-center justify-center items-center'}>
			<IconAlertTriangle
				color={'red'}
				size={96}
			/>
			<h1 className={'pt-6 text-4xl font-semibold domaine'}>An error Occurred!</h1>
			<h3 className={'text-red-500'}>{error.message}</h3>
			<div className={'text-left text-red-400'}>{error.stack}</div>
		</TwContainer>
	);
};

export default NotFound;
